import { useContext } from "react";
import headerImg from "../assets/img/curved-images/curved8.jpg";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap";
import Footer from "../components/Footer";
import $ from "jquery";
import AuthContext from "../controllers/auth";
import NavBar from "../components/NavBar";

const Login = () => {
  const authCtx = useContext(AuthContext);
  const onSubmit = (e) => {
    e.preventDefault();
    let email = $("#email").val().trim();
    let password = $("#password").val().trim();
    authCtx.login({ email: email, password: password });
  };

  return (
    <div>
      <NavBar />
      <header>
        <div className="page-header min-vh-100">
          <div>
            <img
              className={
                "position-absolute fixed-top ms-auto w-lg-50 w-md-50 h-100 z-index-0 d-md-block border-radius-section border-top-end-radius-0 border-top-start-radius-0 border-bottom-end-radius-0"
              }
              src={headerImg}
              alt="ima"
            />
          </div>
          <Container className="">
            <div className="row">
              <Col
                lg={4}
                md={6}
                sm={9}
                className="d-flex justify-content-center flex-column mx-auto "
              >
                <Card className="d-flex blur justify-content-center p-4 shadow-lg my-sm-0 my-sm-6 mt-8 mb-5">
                  <div className="text-center">
                    <h3 className="text-gradient text-danger">Login</h3>
                    <p className="mb-0">
                      Enter your login credentials to assess your data.
                    </p>
                  </div>
                  <Form onSubmit={onSubmit}>
                    <CardBody className="pb-2">
                      <div className="">
                        <label>Email</label>
                        <div className="input-group mb-4">
                          <Input className="" type="email" id={"email"} />
                        </div>
                      </div>
                      <div className="">
                        <Label>Password</Label>
                        <div className="input-group">
                          <Input type="password" className="" id={"password"} />
                        </div>
                      </div>

                      <Row className="">
                        <Col md={12} className="text-center">
                          <Button
                            type="submit"
                            className="btn bg-gradient-primary mt-3 mb-0"
                          >
                            Login
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Form>
                </Card>
              </Col>
            </div>
          </Container>
        </div>
      </header>
      <Footer />
    </div>
  );
};

export default Login;
